/**
 * Emergency-numbers card (SPEC v0.9.3 insert) — replaces the old
 * "ทดลอง · ไม่ใช่ประกาศทางการ" disclaimer on every result card and in the menu.
 * Three rows: phone icon · name · bold red number, each a full-row tel: link with a
 * ≥48px tap target. Dark theme (matches the app). No disclaimer wording.
 */
const NUMBERS: { name: string; sub: string; num: string }[] = [
  { name: "สายด่วนนิรภัย ปภ.", sub: "ภัยพิบัติ น้ำท่วม", num: "1784" },
  { name: "การแพทย์ฉุกเฉิน", sub: "เจ็บป่วย อุบัติเหตุ", num: "1669" },
  { name: "เหตุด่วนเหตุร้าย", sub: "", num: "191" },
];

export function emergencyCard(): HTMLElement {
  const card = document.createElement("div");
  card.className = "emerg-card";
  card.innerHTML = `<div class="emerg-head">📞 เบอร์ฉุกเฉิน</div>` + NUMBERS.map(({ name, sub, num }) =>
    `<a class="emerg-row" href="tel:${num}" aria-label="โทร ${name} ${num}">
      <span class="emerg-ico" aria-hidden="true">📞</span>
      <span class="emerg-name">${name}${sub ? `<span class="emerg-sub">${sub}</span>` : ""}</span>
      <span class="emerg-num">${num}</span></a>`).join("");
  return card;
}
